function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.11 78.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M74.06,49.18c1.91-6.62-1.79-12.3-7.67-15.5M31.88,30.08h-5.38v10.77L1.36,21.11,26.49,1.36v10.77h28.72c12.55-.01,21.53,10.03,21.54,24.15,0,7.14-2.29,13.95-6.42,18.93M49.83,67.73c6.09-.37,10.77-2.62,10.77-5.33v-8.98M60.6,35.47v8.98c0,2.81-5.03,5.12-11.45,5.36M35.47,42.65v-7.18M60.6,35.47c0,2.97-5.63,5.38-12.57,5.38s-12.57-2.41-12.57-5.38,5.63-5.39,12.57-5.39,12.57,2.41,12.57,5.39ZM60.6,44.44v8.98c0,2.71-4.68,4.96-10.77,5.33M19.31,62.39v8.98c0,2.97,5.63,5.39,12.57,5.39s12.57-2.41,12.57-5.39v-8.98M44.44,53.42v8.98c0,2.97-5.63,5.38-12.57,5.38s-12.57-2.41-12.57-5.38v-8.98M44.44,53.42c0,2.97-5.63,5.39-12.57,5.39s-12.57-2.41-12.57-5.39,5.63-5.39,12.57-5.39,12.57,2.41,12.57,5.39Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.72px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico04);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-04.b9e2b380733f5e26514880ecc9fe8e06.svg";
export { ForwardRef as ReactComponent };